<template>
    <div class="detailed-message"
         v-fs-block
         :class="{'is-active': isOpen}">
        <slot
            name="summary"
            :is-open="isOpen"
            :toggle="toggleDetails"/>
        <template v-if="hasDetails && isOpen">
            <slot
                name="details"
                :is-open="isOpen"/>
        </template>
    </div>
</template>

<script>
    import {shortcutTypes} from '@/components/timeline/components/shortcut-types';

    export default {
        name: 'detailed-message',
        props: {
            messageId: {
                type: String,
                required: true,
            },
            hasDetails: {
                type: Boolean,
                required: true,
                default: false,
            },
        },
        inject: ['shortcutBus'],
        data() {
            return {isOpen: false};
        },
        created() {
            this.shortcutBus.$on(shortcutTypes.expandAllEvents, this.openDetails);
            this.shortcutBus.$on(shortcutTypes.closeAllEvents, this.closeDetails);
            this.shortcutBus.$on(shortcutTypes.expandEvent, this.openIfNeed);
            this.shortcutBus.$on(shortcutTypes.closeEvent, this.closeIfNeed);
        },
        beforeDestroy() {
            this.shortcutBus.$off(shortcutTypes.expandAllEvents, this.openDetails);
            this.shortcutBus.$off(shortcutTypes.expandAllEvents, this.closeDetails);
            this.shortcutBus.$off(shortcutTypes.expandEvent, this.openIfNeed);
            this.shortcutBus.$off(shortcutTypes.closeEvent, this.closeIfNeed);
        },
        methods: {
            openIfNeed(id) {
                if (id === this.messageId) {
                    this.openDetails();
                }
            },
            closeIfNeed(id) {
                if (id === this.messageId) {
                    this.closeDetails();
                }
            },
            openDetails() {
                this.isOpen = true;
            },
            closeDetails() {
                this.isOpen = false;
            },
            toggleDetails(e) {
                /**
                 * default behavior if user click on the link
                 */
                if (!e || !e.target || e.target.nodeName !== 'A') {
                    this.isOpen = !this.isOpen;
                }
            },
        },
    };
</script>
